import Search from 'antd/es/input/Search'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { boxFromCode } from '@wolf/barcodes'
import { ScannerConnectedIndicator } from '../../../components/ScannerConnectedIndicator'
import { useSerialScanner } from '../../../hooks/useSerialScanner'
import { usePageOutletContext } from '../../../page-outlet-context'

export const BoxSearchInput = () => {
  const [searchValue, setSearchValue] = useState<string | undefined>(undefined)

  const navigate = useNavigate()

  const { notificationInstance } = usePageOutletContext()

  const showError = (errorMessage: string) =>
    notificationInstance.error({
      description: errorMessage,
      message: 'Caja no encontrada',
    })

  const processBoxCode = useCallback((code?: string) => {
    if (!code) {
      return
    }

    try {
      const params = boxFromCode(code)
      navigate(`/picking/${params.boxId}`)
    } catch (error) {
      showError(`${error}`)
    }

    setSearchValue(undefined)
  }, [navigate, showError])

  const handleBarcode = useCallback((barcode: string) => {
    setSearchValue(barcode)
    processBoxCode(barcode)
  }, [processBoxCode])

  const { isSerialConnected } = useSerialScanner({
    onBarcodeScanned: handleBarcode
  })

  return (
    <div className="flex items-center w-2/4">
      <p>Referencia:</p>
      <Search
        className="flex-1 ml-4"
        placeholder={'Caja'}
        allowClear
        onSearch={() => processBoxCode(searchValue)}
        onChange={(event) => {
          setSearchValue(event.target.value)
        }}
        value={searchValue}
        autoFocus
        enterButton="+"
      />
      { isSerialConnected ? <ScannerConnectedIndicator /> : null }
    </div>
  )
}
